import { tokens, type GriffelStyle } from "@fluentui/react-components";

const borderRadius = "12px";

export const suggestionButtonStyles: GriffelStyle = {
    // Overriding custom property used for `border-color` directly instead of using
    // `...shorthands.borderColor('transparent')` to avoid unnecessary bundle size increase from
    // importing the `shorthands` utility
    "--colorNeutralStroke1": "transparent",
    
    borderRadius,
    boxShadow: tokens.shadow16,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    minWidth: "auto",
    padding: "9px 12px",
    textAlign: "right",
    
    // Adjusting `borderRadius` on focus state to match default state
    "&[data-fui-focus-visible]": {
        borderRadius,
    },
    
    "& strong": {
        fontWeight: tokens.fontWeightSemibold,
    },
};
